"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaNTRecFinalExame = exports.yupNTRecFinalExame = exports.schemaNTRecSem = exports.yupNTRecSem = exports.schemaNTRec = exports.yupNTRec = exports.schemaNTFaltas = exports.yupNTFaltas = exports.schemaNotas = exports.yupNotas = void 0;
const yup = __importStar(require("yup"));
exports.yupNotas = yup.object({
    idMatricula: yup.number().required('A Nota tem que estar associada a uma Matricula').integer().label('Matrícula'),
    idCurso: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Curso'),
    idSerie: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Série'),
    idTurma: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Turma'),
    idMateria: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Matéria'),
    idAluno: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Aluno'),
    nrChamada: yup.string().default('').max(3).label('Número Chamada'),
    nota1: yup.string().default('').max(6).label('Nota Bimestre 1'),
    nota2: yup.string().default('').max(6).label('Nota Bimestre 2'),
    nota3: yup.string().default('').max(6).label('Nota Bimestre 3'),
    nota4: yup.string().default('').max(6).label('Nota Bimestre 4'),
    faltas1: yup.string().default('').max(3).label('Faltas Bimestre 1'),
    faltas2: yup.string().default('').max(3).label('Faltas Bimestre 2'),
    faltas3: yup.string().default('').max(3).label('Faltas Bimestre 3'),
    faltas4: yup.string().default('').max(3).label('Faltas Bimestre 4'),
    r1: yup.string().default('').max(6).label('Recuperação Bimestre 1'),
    r2: yup.string().default('').max(6).label('Recuperação Bimestre 2'),
    r3: yup.string().default('').max(6).label('Recuperação Bimestre 3'),
    r4: yup.string().default('').max(6).label('Recuperação Bimestre 4'),
    ma: yup.string().default('').max(6).label('Média Anual'),
    rec: yup.string().default('').max(6).label('Recuperação Final'),
    ef: yup.string().default('').max(6).label('Exame Final'),
    mf: yup.string().default('').max(6).label('Média Final'),
    media1: yup.string().default('').max(6).label('Média 1'),
    media2: yup.string().default('').max(6).label('Média 2'),
    media3: yup.string().default('').max(6).label('Média 3'),
    media4: yup.string().default('').max(6).label('Média 4'),
    ns1: yup.string().default('').max(6).label('Nota Semestral 1'),
    ns2: yup.string().default('').max(6).label('Nota Semestral 2'),
    rs1: yup.string().default('').max(6).label('Recuperação Semestral 1'),
    rs2: yup.string().default('').max(6).label('Recuperação Semestral 2'),
    ms1: yup.string().default('').max(6).label('Média Semestral 1'),
    ms2: yup.string().default('').max(6).label('Média Semestral 2'),
    sequencia: yup.string().default('').max(3).label('Sequência'),
    aprovado: yup.boolean().required().default(false).label('Aprovado'),
    frequencia: yup.string().default('').max(4).label('Percentual de Frequência'),
    calculo: yup.string().default('').max(1).label('Cálculo'),
    naoreprova: yup.boolean().required().default(false).label('Não Reprovar'),
    conselho: yup.string().default('').max(1).label('Aprovado pelo Conselho'),
    situacao: yup.string().default('').max(1).label('Situação Matéria'),
    tipo: yup.string().default('').max(1).label('Tipo'),
    tipoAp: yup.string().default('').max(2).label('Tipo Aprovação'),
    naocalcmed: yup.boolean().required().default(false).label('Não Efetuar o Cálculo das Medias'),
    pontos1: yup.string().default('').max(6).label('Pontos Bimestre 1'),
    pontos2: yup.string().default('').max(6).label('Pontos Bimestre 2'),
    pontos3: yup.string().default('').max(6).label('Pontos Bimestre 3'),
    pontos4: yup.string().default('').max(6).label('Pontos Bimestre 4'),
    bim1: yup.boolean().required().default(false).label('Dispensado Bimestre 1'),
    bim2: yup.boolean().required().default(false).label('Dispensado Bimestre 2'),
    bim3: yup.boolean().required().default(false).label('Dispensado Bimestre 3'),
    bim4: yup.boolean().required().default(false).label('Dispensado Bimestre 4'),
});
exports.schemaNotas = exports.yupNotas.shape({});
exports.yupNTFaltas = yup.object({
    idNota: yup.number().required().positive().integer().label('ID da nota'),
    idMedia: yup.number().required().positive().integer().label('ID da média'),
    faltas: yup.string().defined().strict(true).label('Faltas'),
    bimestre: yup.number().required().min(1).max(4).label('Bimestre'),
});
exports.schemaNTFaltas = exports.yupNTFaltas.shape({});
exports.yupNTRec = yup
    .object({
    nota: yup.string().defined().strict(true).label('Nota'),
})
    .concat(exports.yupNTFaltas.pick(['bimestre', 'idMedia', 'idNota']));
exports.schemaNTRec = exports.yupNTRec.shape({});
exports.yupNTRecSem = yup
    .object({
    campo: yup.string().required().label('Campo da recuperação'),
    idNotaRec: yup.number().required().positive().integer().label('ID da nota de recuperação'),
    nota: yup.string().defined().strict(true).label('Nota'),
})
    .concat(exports.yupNTFaltas.pick(['idNota']));
exports.schemaNTRecSem = exports.yupNTRecSem.shape({});
exports.yupNTRecFinalExame = yup
    .object({
    nota: yup.string().defined().strict(true).label('Nota'),
    idNotaRec: yup.number().required().positive().integer().label('ID da nota de recuperação'),
})
    .concat(exports.yupNTFaltas.pick(['idNota']));
exports.schemaNTRecFinalExame = exports.yupNTRecFinalExame.shape({});
